// Utility function that checks if the passed in zgEnv is equal to production or production-docker
// Temporary as we will be removing the production-docker environment
export default function isProduction(zgEnv: string | undefined) {
  return zgEnv === 'production' || zgEnv === 'production-docker';
}
